import { ApiRetailerPaymentType } from '@vend/types'
import { PAYMENT_TYPES } from '@vend/business-components'
import { Payment } from '../../models/payment'
import { isReturn } from '../sale'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'

/**
 * Determine if there are any Econduit payments within a collection of payments.
 */
const hasEconduitPayments = (payments: Payment[] = []): boolean => {
  return payments.some(payment => {
    return isEconduitPaymentType(payment.paymentType)
  })
}

/**
 * Determine whether the payment type is an eConduit integrated payment type
 * based on the configuration URL
 */
const isEconduitPaymentType = (
  paymentType: ApiRetailerPaymentType
): boolean => {
  const paymentTypeConfig = paymentType.config
  const paymentTypeUrl = paymentTypeConfig && paymentTypeConfig.url

  return (
    !!paymentTypeUrl && paymentTypeUrl.startsWith('https://econduitapp.com/')
  )
}

/**
 * Returns true if the direct econduit flow should be used (swiper implementation).
 * Returns false if the old iframe flow should be used.
 */
export const shouldUseDirectEconduit = (
  paymentType: ApiRetailerPaymentType
) => {
  return (
    isEconduitPaymentType(paymentType) &&
    paymentType.payment_type?.id !== PAYMENT_TYPES.PAYJUNCTION &&
    paymentType.payment_type?.id !== PAYMENT_TYPES.OTHER_PAYMENT_METHOD
  )
}

/**
 * Evaluates the current sale and determines if the Econduit payment option should be disabled.
 */
export const shouldDisableEconduitPayment = (
  paymentType: ApiRetailerPaymentType,
  sale: Pick<ReduxCurrentSale, 'originalSalePayments' | 'returnFor'>
): boolean => {
  if (isReturn(sale)) {
    const hasMultiplePayments = sale.originalSalePayments.length > 1
    const hasEconduitPayment = hasEconduitPayments(sale.originalSalePayments)
    const isDifferentPaymentType =
      paymentType.type_id !== sale.originalSalePayments[0].paymentType.type_id

    // Disable the button if:
    // - The original sale has multiple payments
    // - or the sale was not paid with an econduit payment type
    // - or the original sale was paid with a different econduit payment type to this one
    if (hasMultiplePayments || !hasEconduitPayment || isDifferentPaymentType) {
      return true
    }
  }

  return false
}
